import type { IResultstash, JsonQuery } from "@mne-core/api";
import { QueryController, createCsrfToken, createHeaders, fetchJsonQuery } from "@mne-core/api";

import type { IAuthorizationData } from "../@types";
import AuthenticationURI from "./AuthenticationURIBuilder";

export interface ITOTPAuthorizationRequest {
  operation: string;
  context: { [key: string]: string };
  nextURI: string;
  tokenCode: string;
}

export interface IAuthorizeTotpOpts extends RequestInit {
  apiUrl: string;
  apiKey?: string;
  sessionKey: string;
  ctrl?: QueryController;
}

export const createRequestAuthorize = (body: ITOTPAuthorizationRequest, opts: IAuthorizeTotpOpts): Request => {
  const { apiUrl, apiKey, sessionKey, ...restOpts } = opts;
  const url = new AuthenticationURI().setApiUrl(apiUrl).setSegment(["totp", "authorize"]);
  const { operation, context, nextURI, tokenCode } = body;

  const headers = createHeaders({
    "ARGUS-API-KEY": apiKey,
    Accept: "application/json",
    "Content-type": "application/json",
    "ARGUS-CSRF-Token": !apiKey ? createCsrfToken(sessionKey, String(url)) : false,
  });

  const localRequestOpts: RequestInit = {
    body: JSON.stringify({ operation, context, nextURI, tokenCode }),
    credentials: "include",
    headers,
    method: "POST",
    mode: "cors",
  };

  return new Request(String(url), {
    ...localRequestOpts,
    ...restOpts,
  });
};

async function authorizeTotp(
  body: ITOTPAuthorizationRequest,
  opts: IAuthorizeTotpOpts,
): Promise<JsonQuery<IResultstash<IAuthorizationData>>> {
  return await fetchJsonQuery<IResultstash<IAuthorizationData>>(createRequestAuthorize(body, opts), {
    ctrl: opts.ctrl || new QueryController(),
  });
}

export default authorizeTotp;
